var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStatusRed = function SvgStatusRed(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 16"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#E45E6A",
    fillRule: "evenodd",
    d: "M2 8a6 6 0 1 0 12 0A6 6 0 0 0 2 8m6-8a8 8 0 1 0 0 16A8 8 0 0 0 8 0",
    clipRule: "evenodd"
  })));
};
export default SvgStatusRed;